import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts, filterProducts, fetchBrandProducts, searchProducts } from '../../features/product/productThunks';
import { clearProducts, clearSearchResults } from '../../features/product/productSlice';
import React, { useEffect, useState } from 'react';
import Filters from '../filters/filters';
import ProductList from '../productList/productList';
import Pagination from '../pagination/pagination';
import './products.css';

export default function Products({ endPoint: propEndPoint, pageType, initialFilters = {}, searchQuery = null }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const brand = location.state?.brand || '';
  const endPoint = propEndPoint || location.state?.endPoint || 'all';

  const { items, searchResults, totalPages, searchTotalPages, loading } = useSelector((state) => state.product);
  const displayedProducts = searchQuery ? searchResults : items;


  const [filters, setFilters] = useState(() => ({
    brand: brand,
    price: [50, 200],
    color: '',
    size: '',
    typeOfProduct: '',
    category: '',
    ...initialFilters,
  }));

  const [currentPage, setCurrentPage] = useState(1);
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(clearSearchResults());
    };
  }, []);

  useEffect(() => {
    dispatch(clearProducts());
    setCurrentPage(1);
    setIsFiltered(false);
  }, [endPoint, searchQuery]);

  useEffect(() => {
    if (searchQuery) {
      dispatch(searchProducts({ query: searchQuery, page: currentPage }));
    } else if (!isFiltered) {
      dispatch(fetchProducts({ endPoint, page: currentPage }));
    }
  }, [dispatch, endPoint, currentPage, isFiltered, searchQuery]);

  const applyFilters = () => {
    setIsFiltered(true);
    dispatch(filterProducts({ filters, page: currentPage }));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (searchQuery) {
      dispatch(searchProducts({ query: searchQuery, page }));
    } else if (isFiltered) {
      dispatch(filterProducts({ filters, page }));
    } else {
      dispatch(fetchProducts({ endPoint, page }));
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="products-container">
      {!searchQuery && (
        <Filters filters={filters} onChange={handleFilterChange} onApply={applyFilters} />
      )}

      <div className="products-content">
        <div style={{ flexGrow: 1 }}>
          <ProductList products={displayedProducts} loading={loading} isSearch={!!searchQuery} />
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={searchQuery ? searchTotalPages : totalPages}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
}
